module.exports = __webpack_public_path__ + "static/media/16UNODC11.3ee2b706.jpg";